import { render, staticRenderFns } from "./StorageTimeReport.vue?vue&type=template&id=b8b870b0&scoped=true"
import script from "./StorageTimeReport.vue?vue&type=script&lang=js"
export * from "./StorageTimeReport.vue?vue&type=script&lang=js"
import style0 from "./StorageTimeReport.vue?vue&type=style&index=0&id=b8b870b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b870b0",
  null
  
)

export default component.exports